import { produce } from 'immer';
import { create } from 'zustand';


const initValues = {
    test: 'testval',
    currentUser: null,
    asideMenu: []
}

const salesContractStore = (set, get) => ({
    ...initValues,
    setCurrentUser: (user) => set(produce(draft => { draft.currentUser = user; })),
    setAsideMenu: (menu) => set(produce(draft => { draft.asideMenu = menu; })),
    resetAsideMenu: () => set(produce(draft => { draft.asideMenu = []; })),
    reset: () => set(initValues)
})

const useStoreArchem = create(salesContractStore);

export default useStoreArchem;